/*
 * @Description: 线索有关语言包
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  是: 'yes',
  否: 'no',
  将: 'will',
  给: 'give',
  原因是: 'reason is',
  转化: 'transformed',
  查看: 'view',
  线索: 'clue',
  商机: 'business opportunity',
  客户: 'customer',
  产品: 'product',
  日程: 'schedule',
  提醒: 'remind',
  重点: 'key point',
  详情: 'details',
  报价单: 'quotation',
  参会人: 'participant',
  已转化: 'transformed',
  请填写: 'please fill in',
  加载中: 'loading',
  联系人: 'contact',
  下一步: 'next step',
  上一步: 'previous step',
  销售合同: 'sales contract',
  销售订单: 'Sales Order',
  售后服务: 'After-sales Service',
  销售线索: 'sales lead',
  新增线索: 'add lead',
  编辑线索: 'edit lead',
  新建日程: 'create schedule',
  编辑日程: 'edit schedule',
  跟进时间: 'follow-up time',
  跟进方式: 'follow-up method',
  日程主题: 'schedule topic',
  转移线索: 'transfer lead',
  导入: 'import',
  点击拨打: 'click to dial',
  温馨提醒: 'kind reminder',
  建议无效: 'Advice invalid',
  客户档案: 'customer file',
  转化信息: 'transformation information',
  客户名称: 'customer name',
  商机名称: 'business opportunity name',
  商机信息: 'business opportunity information',
  系统信息: 'system information',
  基本信息: 'basic information',
  通话记录: 'call record',
  工商信息: 'business information',
  分配记录: 'distribution record',
  转移: 'transfer',
  转移给: 'transfer to',
  转移的原因是: 'transfer reason is',
  领取: 'receive',
  分配给: 'allocate to',
  自动分配给: 'automatically allocate to',
  退回到: 'return to',
  退回原因是: 'return reason is',
  自动退回到: 'automatically return to',
  转移线索池: 'Transfer Clue Pool',
  退回: 'return',
  批量转移: 'bulk transfer',
  是必填项: 'is required',
  是必选项: 'is required selection',
  模板下载: 'template download',
  导入出错: 'import error',
  上传失败: 'upload failed',
  客户信息: 'customer information',
  暂无数据: 'no data',
  正在上传中: 'uploading',
  数据导出中: 'data exporting',
  转化为客户: 'transform to customer',
  转化为: 'transform to ',
  当前负责人: 'current person in charge',
  未找到联系人: 'No contacts found',
  呼叫已拨出: 'The call was dialed',
  出错了: 'Something went wrong',
  最后更新时间: 'Last update time',
  批量转移线索: 'bulk transfer lead',
  模板下载出错: 'template download error',
  查看工商信息: 'view business information',
  关联工商信息: 'related business information',
  数据获取失败: 'failed to get data',
  更新中: 'updating',
  暂无分配记录: 'no distribution record',
  输入日程主题: 'enter schedule topic',
  请选择公司名称: 'please select company name',
  请输入公司名称: 'please enter company name',
  请输入客户名称: 'please enter customer name',
  LP池: 'LP pool',
  LP跟进信息: 'LP follow-up information',
  LP出资信息: 'LP funding information',
  实缴信息: 'Paid-in information',
  基金: 'Fund',
  请输入LP主体名称: 'Please enter the LP principal name',
  请输入LP主体名称或拟投基金名称: 'Please enter LP principal name or proposed fund name',
  请输入基金名称: 'Please enter the name of the fund',
  请选择已关联客户名称: 'please select related customer name',
  只能选择一个负责人: 'only one person in charge can be selected',
  日程主题是必填项: 'schedule topic is required',
  跟进方式是必选项: 'follow up method is required selection',
  请选择跟进方式: 'please select a follow up method',
  Apaas线索导入: 'Apaas lead import',
  跟进时间为必填项: 'follow-up time is required',
  销售线索是必填项: 'sales lead is required',
  获取当前进度失败: 'failed to get current progress',
  公司名称是必填项: 'company name is required',
  无效原因是必填项: 'invalid reason is required',
  跟进人不可编辑: 'follow-up person cannot be edited',
  上传文件格式不正确: 'incorrect file format for upload',
  暂无此线索查看: 'no permission to view this lead',
  请先保存线索基本信息: 'please save the basic lead information first',
  线索转化数据获取失败: 'fail to get lead conversion data',
  线索详情数据获取失败: 'fail to get lead detail data',
  动态记录数据获取失败: 'fail to get follow up record data',
  线索详情EXCEL模板: 'lead detail EXCEL template',
  点击将重新获取Apaas线索数据: 'click to re-acquire Apaas lead data',
  不支持转移的线索名称如下: 'the following lead names do not support transfer',
  点击或拖拽文件到此处上传: 'click or drag the file here to upload',
  apass导入的线索不能转化为商机: 'apass imported lead cannot be converted to business opportunity',
  // ----------------------------------------------------------------
  新增线索数: 'Add Clue',
  待我跟进的: 'Waiting for My Follow-up',
  清空筛选条件: 'Clear Filter Conditions',
  搜索选项外置: 'External Search Options',
  暂无外呼拨打号码: 'No Outbound Dial Number',
  以上指标将横向固定: 'The Above Indicators Will Be Fixed Horizontally',
  请搜索客户名称并选择: 'Please Search and Select Customer Name',
  主叫外显号码: 'Caller Display Number',
  被叫外显号码: 'Called Display Number',
  您收到的来电号码: 'The Incoming Call Number You Received',
  客户收到的来电号码: 'The Incoming Call Number The Customer Received',
  只能选择一个用户: 'Can Only Select One User',
  手机号不能为空: 'Mobile Number Cannot Be Blank',
  姓名不能为空: 'Name Cannot Be Blank',
  搜索流程名称: 'Search Process Name',
  请输入流程名称: 'Please Enter Process Name',
  请选择触发动作: 'Please Select Trigger Action',
  请选择启用状态: 'Please Select Enable Status',
  请选择流程发起对象: 'Please Select Process Initiator',
  请选择对象字段: 'Please Select Object Field',
  商机状态有没选择的: 'There Is Unselected Business Opportunity Status',
  赢率是必填项: 'Win Rate Is Required',
  '请选择省份/城市': 'Please Select Province/City',
  '文件已存在，请修改': 'File Already Exists, Please Modify',
  '请输入字段标识,可用于api对接': 'Please Enter Field Identification, Can Be Used for API Docking',
  '字段标识不能为空,请重新设置': 'Field Identification Cannot Be Blank, Please Reset',
  '停用后该规则将不再可用，是否确认？': 'The Rule Will No Longer Be Available After Deactivation, Are You Sure?',
  '提示信息不能为空,请重新设置': 'Prompt Information Cannot Be Blank, Please Reset',
  '请注意，只可选择一个人员或部门哦': 'Please Note That Only One Person Or Department Can Be Selected',
  '适用范围不能为空，请重新设置': 'Applicable Range Cannot Be Blank, Please Reset',
  '字段名称不能为空,请重新设置': 'Field Name Cannot Be Blank, Please Reset',
  '暂未配置表头，请先配置': 'Header Not Configured Yet, Please Configure First',
  新分配线索: 'The new assignment lead',
  '您非线索池管理员，不可分配线索': 'You can not assign leads unless you are a clue pool administrator',
  分配: 'distribution',
  领取成功: 'Take success',
  录音文件: 'Audio recording file',
  导入新数据: 'Import New Data',
  准备新数据文件: 'Prepare New Data File',
  下载数据模板: 'Download Data Template',
  注意事项: 'Notes',
  '若设置后台开启查重后，重复数据将不会新增': 'If duplicate check is enabled in the background, duplicate data will not be added.',
  '模板中的表头字段名称不可更改，表头行不能删除': 'Header field names in the template cannot be changed, and header rows cannot be deleted.',
  必填项必须保留: 'Required fields must be retained.',
  只能上传excel格式文件: 'Only Excel format files can be uploaded.',
  上传文件: 'Upload File',
  更新现有数据: 'Update Existing Data',
  准备更新数据文件: 'Prepare Update Data File',
  '可从列表页导出含有【唯一ID】字段的数据，【唯一ID】字段将作为匹配原数据的唯一标识，请勿随意修改或删除': 'You can export data with the "Unique ID" field from the list page. The "Unique ID" field will serve as the unique identifier for matching original data. Do not modify or delete it randomly.',
  '文件中必须有【唯一ID】字段，名称不一致或不存在时会导入失败': 'The file must contain a "Unique ID" field. Import will fail if the name is inconsistent or it does not exist.',
  '必填字段若为空，将不会更新该字段': 'If required fields are empty, the field will not be updated.',
  '有些特殊字段不会执行更新，包括有: 自增编码、引用字段、计算字段、附件，等每个对象下赋有特殊逻辑的字段': 'Some special fields will not be updated, including: auto-increment codes, reference fields, computed fields, attachments, and other fields with specific logic assigned under each object.',
  是否触发自动化流程: 'Trigger Automation Process',
  是否触发审批流程: 'Trigger Approval Process',
  字段未填写时是否更新为空值: 'Update to empty value if field is not filled in',
  保存为常用检索: 'Save as common search',
  场景名称: 'Scene name',
  数据范围: 'Data range',
  筛选条件: 'Filter conditions',
  请输入场景名称: '请输入场景名称'
};
